<script setup lang="ts">
import { CatIcon, DogIcon } from '@lucide/vue';
import { Button } from '@/components/ui/button';
import { useMascotStore } from '@/stores/mascot';
import { useRouter } from 'vue-router';
import { isDog } from './mascotProfile';

const mascot = useMascotStore();
const router = useRouter();
</script>

<template>
  <Button
    v-if="mascot.available && mascot.enabled"
    variant="ghost"
    size="icon-sm"
    data-mascot-header-home
    class="w-11"
    :aria-label="mascot.away ? 'Питомец во дворике' : mascot.visible ? 'Спрятать питомца' : 'Позвать питомца'"
    :aria-pressed="mascot.visible"
    :data-tip="mascot.away ? 'Питомец во дворике' : mascot.visible ? 'Спрятать питомца' : 'Позвать питомца'"
    :class="{ 'text-primary': mascot.visible, 'ring-2 ring-primary/50 bg-primary/10': mascot.carrying }"
    @click="mascot.away ? router.push({ name: 'pet-yard' }) : mascot.setHidden(mascot.visible)"
  >
    <DogIcon v-if="isDog(mascot.profile.cat)" /><CatIcon v-else />
  </Button>
</template>
